import { Component, Input, OnInit } from "@angular/core";
import { FlashService } from '@app/services/flash.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: "app-upload-discrepancies-modal",
  templateUrl: "./upload-discrepancies-modal.component.html",
  styleUrls: ["./upload-discrepancies-modal.component.css"]
})

export class UploadDiscrepanciesModal implements OnInit {
  constructor(
    public activeModal: NgbActiveModal,
    private flash: FlashService,
  ){}

  observation = "";
  currentFile = null;

  @Input()
  me: any;

  get isMerchant(){
    return this.me && this.me.role === "merchant"
  }

  get isPM(){
    return this.me && this.me.role === "product-manager"
  }

  get isSupplier(){
    return this.me && this.me.role === "supplier"
  }
  
  ngOnInit(){
  }

  changeFileInput(e){
    if(e.target.files){
      const files = e.target.files;
      if(files && files[0]){
        this.currentFile = files[0]
      }
    }
  }

  acceptModal(){
    let message = ""
    if(this.currentFile === null){
      message = 'Debe subir archivo! \n'
    }

    if(this.observation === ""){
      const observationMessage = 'Debe ingresar motivo para modificar las discrepancias!'
      message = message === "" ? observationMessage : message + observationMessage
    }

    console.log(!this.canObers(), ' - ',message === "",' - ',!this.canObers() || message === "")
    if(!this.canObers() || message === ""){
      this.activeModal.dismiss({ file: this.currentFile, observation: this.observation })
    }else{
      this.flash.emit({ type: 'danger', message: message });
    }
  }

  changeObservation(e){
    this.observation = e.target.value
  }

  messageByUser(){
    const message = this.isMerchant || this.isSupplier ? 
    "Solicitud cambios discrepancias" : "Subir discrepancias"
    return message
  }

  canObers(){
    return this.isMerchant || this.isSupplier ? true : false
  }
}